import { FetchApiClient, noToken } from "@core/ports/http";

import { monitoringPublicApi } from "@apis/monitoring/api";

import { env } from "./env.ts";

export const API = {
  monitoringPublic: new FetchApiClient({
    api: monitoringPublicApi,
    getToken: noToken,
    stage: env.STAGE,
  }).getApi(),
} as const;
